import startCase from 'lodash/startCase';
import { RELEASES_MODEL, RELEASES_TABLE_MODEL } from '../Releases.model';
import { StyledCell } from './Table.style';
import moment from 'moment';
import { setQueryFilter } from 'components/GridChipFilterContainer/helpers';
import CommitShaCell from './cells/CommitShaCell';
import ServicesCell from './cells/ServicesCell';
import ReleaseDetectionCell from './cells/ReleaseDetectionCell';
import ConnectedBranchesCell from './cells/ConnectedBranchesCell';
import QueryString from 'query-string';
import { useHistory } from 'react-router';
import AppRouter from 'common/AppRouter';

const useRows = ({ releases, withIncidentsCount }) => {
  const history = useHistory();
  const navigateToIncidents = ({ release }) => {
    const newQueryString = `?${QueryString.stringify({ git_ref: release })}`;
    history.push({
      pathname: AppRouter.INCIDENTS.path,
      search: newQueryString
    });
  };
  const data = releases?.items || [];
  return data.map(release => {
    const name = release[RELEASES_MODEL.NAME];
    const publishedAt = release[RELEASES_MODEL.PUBLISHED_AT];
    const stage = release[RELEASES_MODEL.STAGE];
    const commitSha = release[RELEASES_MODEL.COMMIT_SHA];
    const connectedBranches = release[RELEASES_MODEL.CONNECTED_BRANCHES] || [];
    const services = release[RELEASES_MODEL.SERVICES] || [];
    const source = release[RELEASES_MODEL.SOURCE];
    const repositoryName = release[RELEASES_MODEL.REPOSITORY_NAME];
    const repositoryId = release[RELEASES_MODEL.REPOSITORY_ID];
    const incidentsCount = release[RELEASES_MODEL.INCIDENTS_COUNT];
    return {
      ...release,
      [RELEASES_TABLE_MODEL.NAME_CELL]: <StyledCell>{name}</StyledCell>,
      [RELEASES_TABLE_MODEL.COMMIT_SHA_CELL]: (
        <CommitShaCell commitSha={commitSha} />
      ),
      [RELEASES_TABLE_MODEL.REPOSITORY_CELL]: (
        <StyledCell
          onClick={() => setQueryFilter({ repositories: repositoryId })}
        >
          {repositoryName}
        </StyledCell>
      ),
      [RELEASES_TABLE_MODEL.PUBLISHED_AT_CELL]: (
        <StyledCell>
          {moment.utc(publishedAt).format('DD MMM YYYY HH:mm')}
        </StyledCell>
      ),
      [RELEASES_TABLE_MODEL.STAGE_CELL]: (
        <StyledCell onClick={() => setQueryFilter({ stages: stage })}>
          {startCase(stage)}
        </StyledCell>
      ),
      [RELEASES_TABLE_MODEL.CONNECTED_BRANCHES_CELL]: (
        <ConnectedBranchesCell connectedBranches={connectedBranches} />
      ),
      ...(withIncidentsCount
        ? {
            [RELEASES_TABLE_MODEL.INCIDENTS]: (
              <StyledCell
                onClick={
                  incidentsCount
                    ? () => navigateToIncidents({ release: commitSha })
                    : undefined
                }
              >
                {incidentsCount}
              </StyledCell>
            )
          }
        : {}),
      [RELEASES_TABLE_MODEL.SERVICES_CELL]: (
        <ServicesCell services={services} />
      ),
      [RELEASES_TABLE_MODEL.RELEASE_DETECTION_CELL]: (
        <ReleaseDetectionCell type={source} />
      )
    };
  });
};

export default useRows;
